import { defineStore } from "pinia";
import axios from "@/utils/axios";
import { useSharedStore } from "@/stores/shared-store";
import { useAuthStore } from "@/stores/auth-store";

export const useUserStore = defineStore("User", {
  state: () => ({
    userNameList: [],
    studentPointList: [],
    ActiveStudents: [],
    ActiveTeachers: [],
    ActivePrincipals: [],
  }),
  getters: {
    userName: (state) => {
      return (id) => {
        // Cari di ActiveTeachers terlebih dahulu
        let user = state.ActiveTeachers?.find((i) => i.userID === id);

        // Jika tidak ditemukan, cari di ActivePrincipals
        if (!user) {
          user = state.ActivePrincipals?.find((i) => i.userID === id);
        }

        if (user) {
          const words = user.name?.split(" ") || [];
          return words.length > 2 ? words.slice(0, 2).join(" ") : (user.name || "-");
        }
        return "-";
      };
    },

    getNamesFromActiveList: () => {
      return (list, idKey = "userID") => {
        const authStore = useAuthStore();

        if (!Array.isArray(list) || list.length === 0) return [];

        if (
          !Array.isArray(authStore.otherUsers) ||
          authStore.otherUsers.length === 0
        )
          return [];

        return list
          .map((obj) => {
            const id = obj[idKey];
            if (!id) return null;

            const user = authStore.otherUsers.find((u) => u.id === id);
            return user ? { label: user.nickname, value: id } : null;
          })
          .filter((item) => item !== null);
      };
    },
    getStudentPoint: (state) => {
      return (studentId) => {
        const student = state.ActiveStudents.find(
          (s) => s.userID === studentId || s.id === studentId,
        );
        return student?.point ?? 0;
      };
    },
  },
  actions: {
    async fetchStudents() {
      const sharedStore = useSharedStore();
      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BE_URL}/api/users/students`,
        );
        this.ActiveStudents = response.data.filter(
          (student) => student.deleted_at === null,
        );
      } catch (error) {
        console.error("Gagal mengambil data student:", error);
      } finally {
        sharedStore.endRequest();
      }
    },

    async fetchTeachers() {
      const authStore = useAuthStore();
      const sharedStore = useSharedStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BE_URL}/api/users/teachers`,
        );
        this.ActiveTeachers = response.data.filter(
          (teacher) => teacher.deleted_at === null,
        );
      } catch (error) {
        console.error("Gagal mengambil data teacher:", error);
      } finally {
        sharedStore.endRequest();
      }
    },

    async fetchPrincipals() {
      const authStore = useAuthStore();
      const sharedStore = useSharedStore();
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BE_URL}/api/users/principals`,
        );
        this.ActivePrincipals = response.data;
      } catch (error) {
        console.error("Gagal mengambil data principal:", error);
      }
    },
  },
});
